import React from 'react';

import { connect } from "react-redux";

import {
  Anchor,
  Avatar,
  Col,
  Row
} from 'antd';

import QueueAnim from 'rc-queue-anim';

import config from '../../utils/config';

const { Link } = Anchor;

const CardSectionInlineInformationAlternate = (
  {
    ...props
  }
) => {

  const {
    innerConfig,
  } = props;

  const localConfig = innerConfig ? innerConfig : config;

  const handleSectionContent = (item) =>
    item.field ?
      localConfig.entity.user[item.field] ?
        localConfig.entity.user[item.field]
        :
        item.content
      :
      item.content
    ;

  return (
    <Row
      justify="initial"
      type="flex"
    >
      <Col
      >
        <Avatar
          src={props.item.avatar}
        />
        <Anchor>
          <Link
            title={handleSectionContent(props.item)}
          >
          </Link>
        </Anchor>
      </Col>
    </Row>
  );
}

export default CardSectionInlineInformationAlternate;
